export enum TCPerformanceFilterRoleEnum {
    LicensedStaff = 1,
    LicensedStaffDescription = 'Licensed Staff',
    ClinicalLiaison = 2,
    ClinicalLiaisonDescription = 'Clinical Liaison'
}
